export default "/048cb1f2b29308e18768c65cfd51e426596a830c/d9f26165e744ef064b81249371ce3c44.svg";